import { render, staticRenderFns } from "./HorizontalImageCtaSectionModule.vue?vue&type=template&id=56c0522b&"
import script from "./HorizontalImageCtaSectionModule.vue?vue&type=script&lang=js&"
export * from "./HorizontalImageCtaSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports